<template>
  <div style="margin-left: 5px">
    <v-btn @click="setAllToEnglish()" v-bind:class="{blue : englishForAll}">Take over english for all</v-btn>
    <div v-if="englishForAll === false">
      <div v-for="(language, code) in languages" :key="code">
        <v-text-field
            :ref="code"
            :label="language"
            :value="getText(code)"
            :hint="getHint(code)"
            :multi-line="isMultiline"
            persistent-hint
          >
          </v-text-field>
      </div>
    </div>
    <div v-if="englishForAll === true">
      <div v-for="(language, code) in languages" :key="code">
        <v-text-field
            :ref="code"
            :label="language"
            :value="($refs['en'][0].value !== $refs['en'][0].lazyValue) ? $refs['en'][0].lazyValue : $refs['en'][0].value"
            :hint="getHint(code)"
            :multi-line="isMultiline"
            persistent-hint
          >
          </v-text-field>
      </div>
    </div>
    <v-btn success @click.native="save()">save</v-btn>
  </div>
</template>

<script>
import objectPath from 'object-path'

export default {
  data() {
    return {
      englishForAll: false,
      englishFieldValue: ''
    }
  },
  props: {
    languages: {
      type: Object,
      required: true
    },
    getText: {
      type: Function,
      required: true
    },
    getDefault: {
      type: Function,
      required: true
    },
    onSave: {
      type: Function,
      required: true
    },
    isMultiline: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    getHint(lang) {
      const text = this.getText(lang)
      const defaultText = this.getDefault(lang)

      if (text !== defaultText) {
        return `Original: ${defaultText}`
      }
    },

    save() {
      let changed = {}

      Object.keys(this.languages)
        .map(code => [
          code,
          true,
          (this.$refs[code][0].value !== this.$refs[code][0].lazyValue) ? this.$refs[code][0].lazyValue : this.$refs[code][0].value  //if value has changed--> new value; if value not changed--> old value
        ])
        .filter(arr => {
          return arr[1]
        })
        .forEach(data => {
          changed[data[0]] = data[2]
        })

      this.onSave(changed)
    },

    setAllToEnglish() {
      if (!this.englishForAll) {
        if (confirm("Do you want to replace all existing translations with the English translation?")) {
          this.englishForAll = !this.englishForAll;
          this.save();
        }
      } else {
        this.englishForAll = !this.englishForAll;
        this.save();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// IsrsI18nDialog.vue?100afec2